export enum Role {
  User = 'User',
  AdminEmp = 'AdminEmp',
  Admin = 'Admin'
}
